// `key` maps to the i18n label. ATTRIBUTE_TYPES keys are the upper-cased
// `attribute_display_type` enum values from the API.
export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
  { id: 8, key: 'TEXT_AREA' },
];

export const getAttributeModelOptions = t =>
  ATTRIBUTE_MODELS.map(model => ({
    ...model,
    option: t(`ATTRIBUTES_MGMT.TABS.${model.key}`),
  }));

export const getAttributeTypeOptions = t =>
  ATTRIBUTE_TYPES.map(type => ({
    ...type,
    option: t(`ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.${type.key}`),
  }));

export const findAttributeType = displayType =>
  ATTRIBUTE_TYPES.find(type => type.key === displayType?.toUpperCase());

// Label for an `attribute_display_type` value; unknown types show as-is.
export const getAttributeTypeLabel = (t, displayType) => {
  const type = findAttributeType(displayType);
  return type ? t(`ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.${type.key}`) : displayType;
};
